import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Themchuyenmon from "components/Dangkiem/Dangkiemvien/Themchuyenmon.js";
import Themtaphuan from "components/Dangkiem/Dangkiemvien/Themtaphuan.js";
import Themcongtac from "components/Dangkiem/Dangkiemvien/Themcongtac.js";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const chuyenmoncolumn = [
  { field: "id", headerName: "ID", width: 50, hide: true },
  {
    field: "tentruong",
    headerName: "Tên trường",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "chuyennganh",
    headerName: "Chuyên nghành đào tạo, bồi dưỡng",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "khoangthoigian",
    headerName: "Từ tháng, năm, đến tháng, năm",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "hinhthucdaotao",
    headerName: "Hình thức đào tạo",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "vanbang",
    headerName: "Văn bằng, chứng chỉ, trình độ gì",
    width: 250,
    headerAlign: "center",
  },
];
const taphuancolumn = [
  { field: "id", headerName: "ID", width: 50, hide: true },
  {
    field: "tenlop",
    headerName: "Tên lớp tập huấn",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "diadiem",
    headerName: "Địa điểm tập huấn",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "khoangthoigian",
    headerName: "Từ ngày, tháng, năm, đến ngày, tháng, năm",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "ketqua",
    headerName: "Kết quả",
    width: 250,
    headerAlign: "center",
  },
];
const congtaccolumn = [
  { field: "id", headerName: "ID", width: 50, hide: true },
  {
    field: "khoangthoigian",
    headerName: "Từ tháng, năm, đến tháng, năm",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "chucdanh",
    headerName: "Chức danh",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "chucvu",
    headerName: "Chức vụ",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "donvicongtac",
    headerName: "Đơn vị công tác",
    width: 250,
    headerAlign: "center",
  },
];
const Capnhatpdkv = React.memo(function Capnhatpdkv(props) {
  const classes = useStyles();
  const { dangkiemvienid } = props;
  const [hoten, setHoten] = React.useState("");
  const [cccd, setCccd] = React.useState("");
  const [trinhdo, setTrinhdo] = React.useState("");
  const [donvi, setDonvi] = React.useState([]);
  const [donvivalue, setDonvivalue] = React.useState(null);
  const [chuyenmon, setChuyenmon] = React.useState([]);
  const [chuyenmonid, setChuyenmonid] = React.useState(0);
  const [taphuan, setTaphuan] = React.useState([]);
  const [taphuanid, setTaphuanid] = React.useState(0);
  const [congtac, setCongtac] = React.useState([]);
  const [congtacid, setCongtacid] = React.useState(0);
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alert2, setAlert2] = React.useState(false);
  const [disableBT, setDisableBT] = React.useState(false);
  const [disableBT1, setDisableBT1] = React.useState(true);
  const [disableBT2, setDisableBT2] = React.useState(true);
  const [disableBT3, setDisableBT3] = React.useState(true);
  const [openthemchuyenmon, setOpenthemchuyenmon] = React.useState(false);
  const [openthemtaphuan, setOpenthemtaphuan] = React.useState(false);
  const [openthemcongtac, setOpenthemcongtac] = React.useState(false);
  const handleClosechuyenmon = () => {
    setOpenthemchuyenmon(false);
    getdaotaochuyenmon();
  };
  const handleClosetaphuan = () => {
    setOpenthemtaphuan(false);
    gettaphuan();
  };
  const handleClosecongtac = () => {
    setOpenthemcongtac(false);
    getcongtac();
  };
  const openthemcm = () => {
    setOpenthemchuyenmon(true);
    getdaotaochuyenmon();
  };
  const openthemth = () => {
    setOpenthemtaphuan(true);
  };
  const openthemct = () => {
    setOpenthemcongtac(true);
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const getdkvtheoid = () => {
    var url =
      Config.backend +
      "/api/DangKiemVien/getdangkiemvientheoid?id=" +
      dangkiemvienid +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setHoten(data[0].ten);
        setCccd(data[0].cccd);
        setTrinhdo(data[0].trinhdocm);
        setDonvivalue({
          id: data[0].trungtamdangkiem_id,
          ten: data[0].trungtamdangkiem,
        });
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getttdangkiem = () => {
    var url =
      Config.backend + "/api/Donvi/gettrungtamdangkiemall?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setDonvi(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const capnhatdangkiemvien = () => {
    var url = Config.backend + "/api/DangKiemVien/capnhatdangkiemvien";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: dangkiemvienid,
        ten: hoten,
        cccd: cccd,
        trinhdocm: trinhdo,
        trungtamdangkiem_id: donvivalue.id,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
        } else showNotification1();
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getdaotaochuyenmon = () => {
    var url =
      Config.backend +
      "/api/DangKiemVien/getdangkiemvientheodkvid?dangkiemvien_id=" +
      dangkiemvienid +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setChuyenmon(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const gettaphuan = () => {
    var url =
      Config.backend +
      "/api/DangKiemVien/getdangkiemvientaphuantheodkvid?dangkiemvien_id=" +
      dangkiemvienid +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTaphuan(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getcongtac = () => {
    var url =
      Config.backend +
      "/api/DangKiemVien/getdangkiemvienqtcttheodkvid?dangkiemvien_id=" +
      dangkiemvienid +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setCongtac(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xoadaotaochuyenmon = () => {
    var url = Config.backend + "/api/DangKiemVien/xoadangkiemviendaotao";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        dangkiemvien_id: dangkiemvienid,
        id: chuyenmonid,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification2();
          getdaotaochuyenmon();
          setDisableBT1(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xoataphuan = () => {
    var url = Config.backend + "/api/DangKiemVien/xoadangkiemvientaphuan";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        dangkiemvien_id: dangkiemvienid,
        id: taphuanid,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification2();
          gettaphuan();
          setDisableBT2(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xoacongtac = () => {
    var url = Config.backend + "/api/DangKiemVien/xoadangkiemvienqtct";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        dangkiemvien_id: dangkiemvienid,
        id: congtacid,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification2();
          getcongtac();
          setDisableBT3(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const showNotification2 = () => {
    setAlert2(true);
    setTimeout(function () {
      setAlert2(false);
    }, 2000);
  };
  React.useEffect(() => {
    getdkvtheoid();
    getttdangkiem();
    getdaotaochuyenmon();
    gettaphuan();
    getcongtac();
  }, []);
  return (
    <div style={{ height: 550, overflowY: "auto" }}>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 10 }}>
              <TextField
                label="Họ và tên"
                variant="outlined"
                size="small"
                value={hoten}
                onChange={(event) => {
                  setHoten(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 10 }}>
              <TextField
                label="Số căn cước công dân"
                variant="outlined"
                size="small"
                value={cccd}
                onChange={(event) => {
                  setCccd(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 10 }}>
              <TextField
                label="Trình độ chuyên môn cao nhất"
                variant="outlined"
                size="small"
                value={trinhdo}
                onChange={(event) => {
                  setTrinhdo(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} style={{ marginTop: 10 }}>
            <FormControl style={{ width: "100%" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={donvivalue}
                getOptionSelected={(option, value) => option.id === value.id}
                options={donvi}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setDonvivalue(value);
                  setDisableBT(false);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Đơn vị công tác"
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "15%" }}>
              <Button
                color="warning"
                variant="contained"
                disabled={disableBT}
                onClick={capnhatdangkiemvien}
                style={{ height: "25px" }}
              >
                Cập nhật
              </Button>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "100%", fontWeight: "bold" }}>
              1. Đào tạo chuyên môn
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <div style={{ height: 180, width: "100%" }}>
              <DataGrid
                getRowId={(row) => row.id}
                rows={chuyenmon}
                columns={chuyenmoncolumn}
                onRowClick={(params) => {
                  setChuyenmonid(params.row.id);
                  setDisableBT1(false);
                }}
                checkboxSelection={false}
                getRowHeight={() => "auto"}
                headerHeight={35}
                hideFooter={true}
                sx={datagridSx}
                initialState={{
                  filter: {
                    filterModel: {
                      items: [],
                      quickFilterLogicOperator: GridLinkOperator.Or,
                    },
                  },
                }}
                components={{ Toolbar: quickSearchToolbar }}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "10%" }}>
              <Button
                color="warning"
                variant="contained"
                onClick={openthemcm}
                style={{ height: "25px" }}
              >
                Thêm
              </Button>
            </FormControl>
            <FormControl style={{ width: "10%", marginLeft: 10 }}>
              <Button
                color="error"
                variant="contained"
                disabled={disableBT1}
                onClick={xoadaotaochuyenmon}
                style={{ height: "25px" }}
              >
                Xóa
              </Button>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "100%", fontWeight: "bold" }}>
              2. Tập huấn nghiệp vụ đăng kiểm xe cơ giới
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <div style={{ height: 180, width: "100%" }}>
              <DataGrid
                getRowId={(row) => row.id}
                rows={taphuan}
                columns={taphuancolumn}
                checkboxSelection={false}
                onRowClick={(params) => {
                  setTaphuanid(params.row.id);
                  setDisableBT2(false);
                }}
                getRowHeight={() => "auto"}
                headerHeight={35}
                hideFooter={true}
                sx={datagridSx}
                initialState={{
                  filter: {
                    filterModel: {
                      items: [],
                      quickFilterLogicOperator: GridLinkOperator.Or,
                    },
                  },
                }}
                components={{ Toolbar: quickSearchToolbar }}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "10%" }}>
              <Button
                color="warning"
                variant="contained"
                onClick={openthemth}
                style={{ height: "25px" }}
              >
                Thêm
              </Button>
            </FormControl>
            <FormControl style={{ width: "10%", marginLeft: 10 }}>
              <Button
                color="error"
                variant="contained"
                disabled={disableBT2}
                onClick={xoataphuan}
                style={{ height: "25px" }}
              >
                Xóa
              </Button>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "100%", fontWeight: "bold" }}>
              3. Tóm tắt quá trình công tác
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <div style={{ height: 180, width: "100%" }}>
              <DataGrid
                getRowId={(row) => row.id}
                rows={congtac}
                columns={congtaccolumn}
                checkboxSelection={false}
                onRowClick={(params) => {
                  setCongtacid(params.row.id);
                  setDisableBT3(false);
                }}
                getRowHeight={() => "auto"}
                headerHeight={35}
                hideFooter={true}
                sx={datagridSx}
                initialState={{
                  filter: {
                    filterModel: {
                      items: [],
                      quickFilterLogicOperator: GridLinkOperator.Or,
                    },
                  },
                }}
                components={{ Toolbar: quickSearchToolbar }}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "10%" }}>
              <Button
                color="warning"
                variant="contained"
                onClick={openthemct}
                style={{ height: "25px" }}
              >
                Thêm
              </Button>
            </FormControl>
            <FormControl style={{ width: "10%", marginLeft: 10 }}>
              <Button
                color="error"
                variant="contained"
                disabled={disableBT3}
                onClick={xoacongtac}
                style={{ height: "25px" }}
              >
                Xóa
              </Button>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12}>
            <Modal
              open={openthemchuyenmon}
              onClose={handleClosechuyenmon}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div>
                <GridContainer>
                  <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={4}>
                    <Card>
                      <CardHeader color="primary" style={{ height: 10 }}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={10}>
                            <FormControl
                              style={{ width: "100%", marginTop: "10px" }}
                            >
                              <h6
                                className={classes.cardTitleWhite}
                                style={{ marginTop: "-5px" }}
                              >
                                Thêm chuyên môn
                              </h6>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={1}></GridItem>
                          <GridItem xs={12} sm={12} md={1}>
                            <FormControl
                              style={{ width: "100%", marginTop: "1px" }}
                            >
                              <CloseIcon onClick={handleClosechuyenmon} />
                            </FormControl>
                          </GridItem>
                        </GridContainer>
                      </CardHeader>
                      <Themchuyenmon dangkiemvienid={dangkiemvienid} />
                    </Card>
                  </GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                </GridContainer>
              </div>
            </Modal>
          </GridItem>
          <GridItem xs={12} sm={10} md={12}>
            <Modal
              open={openthemtaphuan}
              onClose={handleClosetaphuan}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div>
                <GridContainer>
                  <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={4}>
                    <Card>
                      <CardHeader color="primary" style={{ height: 10 }}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={10}>
                            <FormControl
                              style={{ width: "100%", marginTop: "10px" }}
                            >
                              <h6
                                className={classes.cardTitleWhite}
                                style={{ marginTop: "-5px" }}
                              >
                                Thêm tập huấn
                              </h6>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={1}></GridItem>
                          <GridItem xs={12} sm={12} md={1}>
                            <FormControl
                              style={{ width: "100%", marginTop: "1px" }}
                            >
                              <CloseIcon onClick={handleClosetaphuan} />
                            </FormControl>
                          </GridItem>
                        </GridContainer>
                      </CardHeader>
                      <Themtaphuan dangkiemvienid={dangkiemvienid} />
                    </Card>
                  </GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                </GridContainer>
              </div>
            </Modal>
          </GridItem>
          <GridItem xs={12} sm={10} md={12}>
            <Modal
              open={openthemcongtac}
              onClose={handleClosecongtac}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div>
                <GridContainer>
                  <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={4}>
                    <Card>
                      <CardHeader color="primary" style={{ height: 10 }}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={10}>
                            <FormControl
                              style={{ width: "100%", marginTop: "10px" }}
                            >
                              <h6
                                className={classes.cardTitleWhite}
                                style={{ marginTop: "-5px" }}
                              >
                                Thêm công tác
                              </h6>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={1}></GridItem>
                          <GridItem xs={12} sm={12} md={1}>
                            <FormControl
                              style={{ width: "100%", marginTop: "1px" }}
                            >
                              <CloseIcon onClick={handleClosecongtac} />
                            </FormControl>
                          </GridItem>
                        </GridContainer>
                      </CardHeader>
                      <Themcongtac dangkiemvienid={dangkiemvienid} />
                    </Card>
                  </GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                </GridContainer>
              </div>
            </Modal>
          </GridItem>
        </GridContainer>
      </CardBody>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Xóa thành công"
            open={alert2}
            closeNotification={() => setAlert2(false)}
            close
          />
        </GridItem>
        <GridContainer>
          <GridItem xs={12} sm={12} md={10} lg={8}>
            <Snackbar
              place="tc"
              color="warning"
              icon={AddAlert}
              message="Có lỗi trong quá trình cập nhật"
              open={alert1}
              closeNotification={() => setAlert1(false)}
              close
            />
          </GridItem>
        </GridContainer>
      </GridContainer>
    </div>
  );
});

Capnhatpdkv.propTypes = {
  dangkiemvienid: PropTypes.number,
};
export default Capnhatpdkv;
